// extracted by css-extract-rspack-plugin
export default {"HeatmapCellDividers":"HeatmapCellDividers--_7E5H"};